import { Phone } from "lucide-react";

// Direct phone call button. The recording prompt was removed per user request.
const CallPrompt = ({ phone, name, className = "", testid, buttonLabel = "Call" }) => (
  <button
    type="button"
    aria-label={`Call ${name}`}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = `tel:${phone}`;
    }}
    className={className}
    data-testid={testid}
  >
    <Phone size={12} /> {buttonLabel}
  </button>
);

export default CallPrompt;
